import { Directive, Input, Signal } from '@angular/core'
import { ApiResult, RemoteData } from '../../lib/remote-data'

interface ImplicitContext<T> {
  $implicit: T
  [index: string]: any
}

@Directive({
  selector: '[ftrTypedContext]',
  standalone: true,
})
export class TypedContextDirective<T> {
  @Input()
  ftrTypedContext?: ApiResult<T> | Signal<RemoteData<T>> | RemoteData<T>

  static ngTemplateContextGuard<T>(_dir: TypedContextDirective<T>, _ctx: unknown): _ctx is ImplicitContext<T> {
    return true
  }
}
